import { loubiAirwaysBoutiqueId, loubiAirwaysCnBoutiqueId, loubiFutureSiteId } from '../config';

export const storesWithCookieBanner = [
  loubiAirwaysBoutiqueId,
  loubiAirwaysCnBoutiqueId,
  loubiFutureSiteId
];
